'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import Mixpanel from '@/lib/mixpanel';
import { useEffect } from 'react';

export default function MixpanelAnalytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      // 当路径或查询参数变化时，跟踪页面浏览
      const url = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '');
      Mixpanel.pageView(url);
    }
  }, [pathname, searchParams]);

  return null; // 这个组件不渲染任何内容
}